import React from 'react';
import PropTypes from 'prop-types';
import { ItemList } from './ItemList';
import { store } from '../../store';
import { IneligibleItemsWrapper } from './style';

export const IneligibleItems = ({ ineligibleByDay = [], naItems = [] }) => {
  if (ineligibleByDay.length + naItems.length === 0) return null;
  const { language } = store.getState();

  return (
    <IneligibleItemsWrapper>
      <h4 className="ineligible-header">{language['returns.step_1.na_returns_header']}</h4>
      <ItemList
        items={ineligibleByDay && ineligibleByDay.length > 0 ? ineligibleByDay : naItems}
        disabled={(ineligibleByDay && ineligibleByDay.length > 0 ? ineligibleByDay : naItems).map(
          (e) => e.item_id,
        )}
        ineligible
      />
    </IneligibleItemsWrapper>
  );
};

IneligibleItems.propTypes = {
  ineligibleByDay: PropTypes.arrayOf(PropTypes.object),
  naItems: PropTypes.arrayOf(PropTypes.object),
};

IneligibleItems.defaultProps = {
  ineligibleByDay: [],
  naItems: [],
};
